export enum EORDER_PARAMS {
  STATUS = 'status',
  TRANSACTION_ID = 'transaction_id',
  EXTERNAL_ID = 'external_id',
  TOKEN = 'tx',
}

export enum EORDER_STATUS {
  PROCESSED = 'processed',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}
